// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SpeakersTab-modulewrapper3Ak","active":"SpeakersTab-moduleactive15b","icon":"SpeakersTab-moduleiconJ9a","text":"SpeakersTab-moduletext3Ka"};